import { render } from "./ImageCapitalIcons.vue?vue&type=template&id=fa727a38&scoped=true"
import script from "./ImageCapitalIcons.vue?vue&type=script&lang=js"
export * from "./ImageCapitalIcons.vue?vue&type=script&lang=js"

import "./ImageCapitalIcons.vue?vue&type=style&index=0&id=fa727a38&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa727a38"]])

export default __exports__